<ng-container *transloco="let convert;">
  @if (!waitingResponse && !successfulResponse && intialOffer) {
    <app-offer-modals-header
      heading="{{ convert('vehicles.initialOffer.textMakeOffer') }}"
      [tenantName]="tenantName"
      [headingId]="modalId + '-title'"
    ></app-offer-modals-header>
    <p class="text-danger fw-bold general-error" role="alert" data-test-id="app-initial-offer-e-general-error-text" [class.d-none]="!errorMessage" aria-atomic="true" aria-live="polite" #error>
      @if (errorMessage) {
        {{ showGeneralErrorMessage }}
      }
    </p>
    @if (showWarning) {
      <app-vehicle-changed-warning></app-vehicle-changed-warning>
    }
    <div class="modal__content">
      <!--
        The comp's vehicle identification block (Figma 10360:9077): the title in bold with the VIN on
        the line beneath it, between the 'Make Offer' heading and the breakdown. Same block, same
        markup and the same reasoning as Buy Now's and the bid modal's.

        It is gated on the flag rather than rendered unconditionally because flag-off tenants already
        name the vehicle -- their #disclosures prose below reads '... place an offer on the 2024 Jeep
        Wagoneer L Series III - VIN 1C4SJ...' -- so rendering this as well would state it twice. The
        all-in binding sentence that replaces that prose names neither, which is what QA raised and
        what the comp answers by lifting both out to here.

        The VIN keeps .stockwave-bid-buy-vin. Stockwave reads the VIN out of that hook and it existed
        only in the flag-off prose, so with the flag on this modal exposed no VIN for the extension to
        find; this restores it.
      -->
      @if (showDripBreakdown) {
        <p class="make_offer_vehicle">
          <span class="make_offer_vehicle__title">{{ item.titleSimple }}</span>
          <span class="make_offer_vehicle__vin">{{ convert('common.textVin') }} <span class="stockwave-bid-buy-vin">{{ vin }}</span></span>
        </p>
      }
      <!--
        M4.13: flag OFF only. With all-in pricing on, ONE paragraph below the breakdown replaces
        every block in here -- see the drip block inside the form. This whole div is gated rather
        than rewritten in place because the comp puts the prose AFTER the price breakdown, and the
        breakdown lives inside the <form> below while these blocks sit above it. #disclosures is
        referenced nowhere -- no styles, no tests, no aria -- so removing it with the flag on is
        safe. Flag off, everything below renders exactly as today, in today's order.
      -->
      @if (!showDripBreakdown) {
        <div id="disclosures">
          <p data-test-id="app-initial-offer-e-modal-info-text">
            <strong>{{initialOfferTranlations.msgDescriptionImportant}}</strong>
            {{initialOfferTranlations.msgDescriptionBySelecting}}
            <strong>{{initialOfferTranlations.msgDescriptionMakeOffer}}</strong>
            {{initialOfferTranlations.msgDescriptionPartOne}}
            {{vehicleTitle}} <span class="stockwave-bid-buy-vin">{{vin}}</span> {{initialOfferTranlations.msgDescriptionPartTwo}}
          </p>
          <!--
            No gate: showTransportationParagraph was `flag on ? is a fee quoted : true`, and this is
            the flag-off branch, so it was always true here. The flag-on gate is
            showTransportationDisclosure, on the drip paragraph inside the form.
          -->
          <p data-test-id="app-initial-offer-e-modal-transportation-text">
            {{initialOfferTranlations.msgDescriptionTransportaion}}
          </p>
          <ng-container *ngTemplateOutlet="financeSourceFeeMessage"></ng-container>
          @if (showSellingDisclosure) {
            <p>
              {{ convert('vehicles.initialOffer.showSellingDisclousure') }}
              <ng-container *ngTemplateOutlet="SellingDisclosuresLink"></ng-container>.
              </p>
            }
          </div>
      }
        <form name="makeOfferForm" [formGroup]="form" (ngSubmit)="$event.preventDefault(); newOffer()" novalidate allytm-async>
          <div class="row">
            <ng-container *ngTemplateOutlet="OfferAmountOrBreakdown"></ng-container>
            <!--
              M4.13, flag ON: the comps (Figma 10493:16256) mark today's "Important: By selecting
              Make Offer ..." paragraph hidden and put ONE sentence in its place, below the price
              breakdown, with the Selling Disclosures acceptance folded into it and the
              transportation sentence as its own paragraph.

              The quoted figure is the breakdown's own total, transportation INCLUDED -- see
              offerQuotedPriceDisplay. This reverses M4.4's note that the prose should stay as it
              is: that was written when no comp for the all-in wording existed, and the reasoning
              was that for an offer the fees genuinely ARE added on top of the amount the buyer
              names, so today's sentence is not the misstatement it is under Buy Now. True, but
              the comp answers a different question -- what the buyer is bound to -- and answers
              it with the total they can see directly above.

              The data-test-ids are deliberately the SAME as the flag-off paragraphs' rather than
              new ones: only one branch ever renders, and the automation suite looks for the info
              text and the transportation text by those names regardless of which copy is in place.
            -->
            @if (showDripBreakdown) {
              <div class="col-12">
                <p id="mom_binding_text" data-test-id="app-initial-offer-e-modal-info-text">
                  <span [innerHTML]="convert('vehicles.initialOffer.msgBindingOfferAllInPartOne')"></span>
                  <!--
                    Split around the link rather than embedding an anchor in the translation string:
                    the href is config-driven and routerLink cannot be applied through [innerHTML].

                    No whitespace between the outlet and part two -- part two opens with '.', and a
                    newline there would render 'Selling Disclosures .'
                  -->
                  <ng-container *ngTemplateOutlet="SellingDisclosuresLink"></ng-container><span
                    [innerHTML]="convert('vehicles.initialOffer.msgBindingOfferAllInPartTwo', { amount: offerQuotedPriceDisplay })"></span>
                </p>
                @if (showTransportationDisclosure) {
                  <p id="mom_transportation_text" data-test-id="app-initial-offer-e-modal-transportation-text"
                    [innerHTML]="convert('vehicles.initialOffer.msgTransportationOptional')"></p>
                }
                <ng-container *ngTemplateOutlet="financeSourceFeeMessage"></ng-container>
              </div>
            }
            <div class="col-12 errorBox" aria-atomic="true" aria-live="polite">
              @if (showBackendError) {
                <p class="text-danger fw-bold" id="offer-amount-error" role="alert" data-test-id="app-initial-offer-e-backend-error-text" role="alert">{{ convert('error.' + errorMessage) }}</p>
              }
              @if (showValidAmountErrorMsg && !isViewOnly) {
                <p class="text-danger fw-bold" id="offer-amount-error" role="alert" data-test-id="app-initial-offer-e-enter-valid-amount-error-text" role="alert">{{ initialOfferTranlations.enterValidAmount }}</p>
              }
            </div>
          </div>
          <div class="d-flex flex-column app-textarea form-group mb-0">
            <!--
              The comp (Figma 10360:9108) labels this field for what it is -- a message to the seller
              -- rather than 'COMMENTS (OPTIONAL)', and gives the box a 'Comment' placeholder.
              Flag-off keeps today's label, so the change lands only where the comp applies.

              initialOffer.labelSellerQuestion, not the sellerUpdate key with the same name: the comp
              reads 'ASK SELLER QUESTION:' where seller-updates asks 'Ask seller a question:', so
              borrowing that value and re-casing it would have retitled a panel with no comp. Its own
              key under this modal's namespace is the smaller change -- the same reasoning, and the
              same shape, as textOfferHistory vs textHistory in offer-history.

              Uppercase at source, like labelComment and labelOfferAmount beside it, so no CSS
              text-transform is needed. French keeps its article: 'Posez une question au vendeur' has
              no 'a' to drop and 'Posez question' is not French.

              The placeholder is an existing key reused as-is -- the same word in the same kind of box
              on edit-comment -- so there is nothing new to translate for it.
            -->
            <label class="d-block text-start make-offer-comment-label" for="mom_comments_textbox">{{
              showDripBreakdown
                ? convert('vehicles.initialOffer.labelSellerQuestion')
                : convert('vehicles.initialOffer.labelComment')
            }}</label>
            <textarea
              id="mom_comments_textbox"
              cols="50"
              rows="5"
              maxlength="150"
              [attr.placeholder]="showDripBreakdown ? convert('shared.editComment.placeholderComment') : null"
              formControlName="offerComment"
              appCharacterCount
              #comment="appCharacterCount"
              (keyup)="replaceInvalidCharacters($event)"
              allytmfn="make-offer-comment"
            ></textarea>
            <app-character-count
              [count]="comment.count$ | async"
              [maxLength]="150"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
          </div>
          <div class="mt-3 d-flex flex-column flex-lg-row lg-justify-content-start action-buttons">
            <button
              id="mom_make_offer_button"
              class="btn btn-primary stockwave-bid-button"
              type="submit"
              data-track-elem="button"
              data-track-name="Make Offer"
              allytmln='makeBuyAction'
              >
              {{ convert('vehicles.initialOffer.btnMakeOffer') }}
            </button>
            <button
              id="mom_cancel_button"
              class="ms-lg-2 mt-3 mt-lg-0 btn btn-link"
              type="button"
              (click)="cancel()"
              data-track-elem="button"
              data-track-name="Cancel"
              data-track-trigger="close"
              >
              <span>{{ convert('common.btnCancel') }}</span>
            </button>
          </div>
        </form>
      </div>
      <app-modal-close (close)="cancel()" [identifier]="'mom_close_x_button'"></app-modal-close>
    }

    @if (!waitingResponse && !successfulResponse && !intialOffer) {
      <app-higher-existing-offer
        #HigherExistingOfferComponent
        [offerAmount]="form.get('offerAmount').value"
        [highestOfferAmount]="highestOfferAmount"
        (continueOffer)="continue()"
        (cancelOffer)="cancel()"
        (backOffer)="back()"
      ></app-higher-existing-offer>
    }

    @if (waitingResponse && !successfulResponse) {
      <!-- submitting -->
      <app-action-submitting actionText="{{ convert('vehicles.initialOffer.actionTextSubmittingOffer') }}"></app-action-submitting>
    }

    @if (!waitingResponse && successfulResponse) {
      <!-- success -->
      <app-action-submitted
        (close)="cancel()"
        actionText="{{ convert('vehicles.initialOffer.actionTextOfferSubmitted') }}"
        [tenantName]="tenantName"
      ></app-action-submitted>
    }

    <!--
      The Selling Disclosures link, extracted in M4.13 so today's disclosure paragraph and the new
      binding sentence share ONE definition of it instead of two that can drift apart. The markup
      inside is the existing anchor verbatim, attributes and all.

      The @else branch is not padding. showSellingDisclosure gates the disclosuresLinkEnabled flag,
      and with that flag off the binding sentence still has to read "... and you accept the Selling
      Disclosures." -- the words stay, only the anchor goes. Without it part one would end
      mid-phrase on "the". The flag is named for the LINK, so dropping the link and keeping the
      noun is what it asks for. The legacy paragraph keeps its own outer @if, so nothing renders
      there either way.
    -->
    <ng-template #SellingDisclosuresLink>
      @if (showSellingDisclosure) {
        <strong
          ><a
          target="_blank"
          rel="opener"
          routerLink="{{ sellingDisclosureUrl }}"
          data-track-elem="button"
          data-track-name="Selling Disclosures"
          [attr.aria-label]="convert('vehicles.initialOffer.areaLabelSellingDisclosure')"
          >{{ convert('vehicles.initialOffer.textSellingDisclosures') }}</a
          ></strong
          >
      } @else {
        <strong>{{ convert('vehicles.initialOffer.textSellingDisclosures') }}</strong>
      }
    </ng-template>

    <ng-template #financeSourceFeeMessage>
      @if (isFinanceSourceFeeIncluded()) {
        <p aria-labelledby="bid-modal-finance-source-fee-text" [innerHTML]="convert('vehicles.bidModal.textFinanceSourceFee',{name: financeSource.financeSourceName, amount: financeSource.feeAmount})"></p>
      }
    </ng-template>

    <!--
      The currency field itself, with no label of its own, so the two hosts below can each supply the
      labelling their layout needs. Extracted rather than copied: it is the only place the buyer names
      the amount their offer binds them to, and two copies drifting -- a mask, a separator, an id --
      is a money defect. offerAmountInputConfig carries whichever labelledby the rendered layout has.
    -->
    <ng-template #OfferAmountInput>
      <app-currency-input
        [inputConfig]="offerAmountInputConfig"
        [inputForm]="form"
        [inputId]="'offer-amount'"
      ></app-currency-input>
    </ng-template>

    <!--
      Today's amount block: its own label above the field. Used whenever the all-in breakdown is not
      rendering, which is every flag-off case.
    -->
    <ng-template #OfferAmount>
      <div class="col-md-6 col-12 input__offer-amount">
        <div class="form-group mb-4 mb-sm-3">
          <label for="offer-amount" id="offer-amount-label" class="text-uppercase">{{ convert('vehicles.initialOffer.labelOfferAmount') }}</label>
          <ng-container *ngTemplateOutlet="OfferAmountInput"></ng-container>
        </div>
      </div>
    </ng-template>

    <!--
      All-in pricing (M4.4), Pattern B. The field moves inside the breakdown, labelled by the
      breakdown's own base-amount label -- which is why the <label> above is not rendered here too --
      with the required fees and optional transportation itemised beneath it and the total updating as
      the buyer types.

      The projected wrapper must carry appModalPriceBreakdownAmount: content matching no ng-content
      selector is discarded silently rather than rendered, so the field would simply vanish without it.
    -->
    <ng-template #AllInBreakdown>
      <div class="col-12 mb-4 mb-sm-3">
        <!--
          [showCents]="false" per the comp (Figma 10360:9077), which quotes OFFER AMOUNT $50,000,
          SERVICE FEE $400, TRANSPORTATION FEE $350 and TOTAL PURCHASE PRICE $50,750 -- whole dollars
          in every row. Paired with offerQuotedPriceDisplay's withCents: false, and the two must move
          together: the binding sentence quotes the same total this block's last row shows, so a
          mismatch writes one figure two ways inside one modal.

          Bound here rather than flipping ModalPriceBreakdownComponent's default, which stays
          input(true) for the legacy BidModalComponent. Same call as View Offer's.
        -->
        <app-modal-price-breakdown
          [idPrefix]="dripIdPrefix"
          [pattern]="additivePattern"
          [baseAmount]="dripOfferBaseAmount"
          [feeRows]="dripFeeRows"
          [transportationFee]="dripTransportationFee"
          [showCents]="false"
          [translations]="dripBreakdownTranslations"
          [useProjectedAmount]="true"
          [inlineControlOnNarrow]="true">
          <span appModalPriceBreakdownAmount class="offer-amount-breakdown-control">
            <ng-container *ngTemplateOutlet="OfferAmountInput"></ng-container>
          </span>
        </app-modal-price-breakdown>
      </div>
    </ng-template>

    <ng-template #OfferAmountOrBreakdown>
      @if (showDripBreakdown) {
        <ng-container *ngTemplateOutlet="AllInBreakdown"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="OfferAmount"></ng-container>
      }
    </ng-template>
  </ng-container>
